import Vue from 'vue'
import API from '@/api.js'
import {
	Message
} from 'element-ui'

//新的集成上传逻辑


export async function LayerType() {
	let list = [{
		value:1,
		label:"严格按序"
	},
	{
		value:2,
		label:"顺序包含"
	},
	{
		value:3,
		label:"仅方法比对"
	},
	{
		value:4,
		label:"方法最后值比对"
	},
	]
	
	return list
}

/**
 * 1. 获取后端 OSS 上传凭证
 */
export async function getUploadParam(courseClassId, studentId, Type) {
	let type = Type
	try {
		const res = await API.get(API.fileurl.getUploadParam, {
			type: type,
			schoolId: localStorage.getItem('orgId') || '',
			courseClassId: courseClassId || '',
			studentId: studentId || '',
			userId: localStorage.getItem('userId')
		})
		return res.data
	} catch (err) {
		console.error('获取上传凭证失败：', err)
		Message.error('获取上传参数失败')
		throw err
	}
}

/**
 * 2. 直传阿里云OSS
 */
export async function uploadToOss(file, ossData, src) {
	console.log('1file', file)
	if (!file || !ossData) throw new Error('file / ossData 不能为空')
	if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

	// 处理路径
	const host = ossData.host.replace(/\/$/, '')
	const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
	const ext = file.name.split('.').pop().toLowerCase() || 'png'
	const key = `${dir}${ossData.uuid}.${ext}`

	const formData = new FormData()
	formData.append('key', key)
	formData.append('OSSAccessKeyId', ossData.accessKeyId)
	formData.append('policy', ossData.policy)
	formData.append('signature', ossData.signature)
	formData.append('file', file)

	try {
		const controller = new AbortController()
		const timer = setTimeout(() => controller.abort(), 30000)

		const res = await fetch(host, {
			method: 'POST',
			body: formData,
			signal: controller.signal
		})

		clearTimeout(timer)

		if (res.status === 200 || res.status === 204) {

			let url = `${host}/${key}`
			if (src) {
				url = key
			}
			console.log('✅ 上传成功：', url)
			return url
		}

		const errMsg = await res.text()
		console.error('❌ OSS 报错：', res.status, errMsg)
		throw new Error(`上传失败 ${res.status}`)
	} catch (err) {
		console.error('❌ 上传异常：', err)
		const msg = err.name === 'AbortError' ? '上传超时' : err.message
		throw new Error('上传失败：' + msg)
	}
}

/**
 * 3. 上传完成回调（回写数据库）
 */
export async function uploadFileCallback(file, realUrl, ossData, courseClassId, studentId, imgType, imgTypeName) {
	try {
		let messageList = [{
			"content": realUrl,
			"fileType": "img",
			"imgType": imgType,
			"imgTypeName": imgTypeName,
			"likeCount": 0,
			"fileSize": file.size
		}]

		// ✅ 接收后端返回结果（包含 id）
		const res = await API.post(API.school.postChat, {
			schoolId: localStorage.getItem('orgId'),
			courseClassId: courseClassId,
			studentId: studentId,
			source: 2,
			role: "student",
			imgType: imgType,
			messageList: messageList
		})

		// ✅ 成功时把后端数据返回出去

		if (res.data.code === 200) {
			return res.data // 这里返回 { id, fileId, code... }
		} else {
			Message.error('保存记录失败')
			throw new Error('保存失败')
		}
	} catch (err) {
		console.error('回调失败：', err)
		Message.error('保存记录失败')
		throw err
	}
}

/**
 * 4. 完整流程：获取凭证 → 上传 → 回调  最新的逻辑
 */
export async function fullUploadImage(file, courseClassId, studentId, imgType, Type, imgTypeName) {
	const ossData = await getUploadParam(courseClassId, studentId, Type)
	console.log('ossData', ossData)
	const realUrl = await uploadToOss(file, ossData, '地址')
	console.log('realUrl', realUrl)
	var id = ''
	if (imgType != 'adminIcon' && imgType != 0) {
		const isCallback = await uploadFileCallback(file, realUrl, ossData, courseClassId, studentId, imgType,
			imgTypeName)

		if (isCallback && isCallback.data) {
			id = isCallback.data
		}
	}

	return {
		url: realUrl,
		id: id
	}
}

// 本地图片转 base64（用于预览）
export function fileToBase64(file) {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.onload = (e) => resolve(e.target.result)
		reader.readAsDataURL(file)
	})
}

// 工具：base64 → File 对象（和手动上传一样格式）
function dataURLToFile(dataurl, filename = "icon.png") {
	let arr = dataurl.split(',')
	let mime = arr[0].match(/:(.*?);/)[1]
	let bstr = atob(arr[1])
	let n = bstr.length
	let u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new File([u8arr], filename, {
		type: mime
	})
}

// 上传单个图片（自动把 base64 变成 File 给接口）
export async function fullUploadImages(fileOrBase64) {
	try {
		let file = fileOrBase64

		// ✅ 关键：如果是 base64，自动转成 File 对象（和手动上传一样）
		if (typeof fileOrBase64 === 'string' && fileOrBase64.startsWith('data:image')) {
			file = dataURLToFile(fileOrBase64, "icon.png")
		}

		const ossData = await getUploadParam('', '', "adminIcon")
		const realUrl = await uploadToOss(file, ossData) // 现在接口拿到的是完整 File
		return realUrl
	} catch (err) {
		console.error('上传失败', err)
		throw err
	}
}

// 递归遍历 config，把所有 base64 图标批量上传并替换成 URL
export async function uploadAllIcons(obj) {
	if (!obj) return obj

	// 底部菜单数组
	if (Array.isArray(obj)) {
		for (let item of obj) {
			await uploadAllIcons(item)
		}
		return obj
	}

	// 对象遍历
	for (let key in obj) {
		const val = obj[key]
		if (typeof val === 'string' && val.startsWith('data:image/')) {
			// 是 base64 图片 → 上传
			obj[key] = await fullUploadImages(val)
		} else if (typeof val === 'object' && val !== null) {
			await uploadAllIcons(val)
		}
	}
	return obj
}

//获取html上传密钥
export async function CustomHtmlUploadParam(courseClassId) {
	try {
		const res = await API.get(API.fileurl.getCustomHtmlUploadParam, {
			orgId: localStorage.getItem('orgId') || '',
			courseClassId: courseClassId || '',
			userType: localStorage.getItem('userType'),
			userId: localStorage.getItem('userId'),
		})
		return res.data
	} catch (error) {
		console.error('获取上传凭证失败：', error)
		Message.error('获取上传参数失败')
		throw error
	}
}
export async function HtmlToOss(file, typeId, courseClassId) {
	//执行请求地址

	const fileraw = file
	let url = ''
	var name = file.name
	var size = file.size

	try {
		const ossData = await CustomHtmlUploadParam(courseClassId)
		//执行上传服务器
		url = `${ossData.dir}${ossData.uuid}.html`
		const realUrl = await htmlUploadToOss(fileraw, ossData)
		//执行数据写入数据库并且返回数据库地址
		const htmlIN = await htmlForMysql(name, size, url, courseClassId)
		// 2026-07-17 HTML upload record: keep old string return and expose record id for config rendering.
		const htmlUploadRecordId = getHtmlUploadRecordIdFromResult(htmlIN)
		HtmlToOss.lastHtmlUploadRecordId = htmlUploadRecordId
		HtmlToOss.lastResult = {
			url,
			htmlUploadRecordId
		}
		if (htmlIN) {
			return url
		} else {
			return ''
		}
	} catch (err) {
		return ''
	}

}

function getHtmlUploadRecordIdFromResult(result) {
	if (!result) return ''
	if (typeof result === 'number' || typeof result === 'string') return result
	const data = result.data !== undefined ? result.data : result
	if (typeof data === 'number' || typeof data === 'string') return data
	if (!data || typeof data !== 'object') return ''
	if (data.id !== undefined) return data.id
	if (data.htmlUploadRecordId !== undefined) return data.htmlUploadRecordId
	if (data.htmlId !== undefined) return data.htmlId
	if (data.recordId !== undefined) return data.recordId
	return ''
}
export async function htmlForMysql(name, size, url, courseClassId) {
	try {
		const postHtml = await API.post(API.fileurl.postHtmlSave, {
			name: name,
			size: size,
			url: url,
			aiStandardModelId: courseClassId,
			orgId: localStorage.getItem('orgId'),
			userId: localStorage.getItem('userId'),
			userType: localStorage.getItem('userType'),
			typeId: 1
		})
		return postHtml && postHtml.data && postHtml.data.data !== undefined ? postHtml.data.data : true
	} catch (err) {
		console.log('err', err)
		return false
	}

}
export async function htmlUploadToOss(fileraw, ossData) {
	console.log('fileraw', fileraw)
	if (!fileraw || !ossData) throw new Error('file / ossData 不能为空')
	if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

	// 处理路径
	const host = ossData.host.replace(/\/$/, '')
	const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
	const ext = fileraw.name.split('.').pop().toLowerCase() || 'html'
	const key = `${dir}${ossData.uuid}.${ext}`

	const formData = new FormData()
	formData.append('key', key)
	formData.append('OSSAccessKeyId', ossData.accessKeyId)
	formData.append('policy', ossData.policy)
	formData.append('signature', ossData.signature)
	formData.append('file', fileraw)

	try {
		const controller = new AbortController()
		const timer = setTimeout(() => controller.abort(), 30000)

		const res = await fetch(host, {
			method: 'POST',
			body: formData,
			signal: controller.signal
		})

		clearTimeout(timer)

		if (res.status === 200 || res.status === 204) {
			const url = `${host}/${key}`
			console.log('✅ 上传成功：', url)
			return url
		}

		const errMsg = await res.text()
		console.error('❌ OSS 报错：', res.status, errMsg)
		throw new Error(`上传失败 ${res.status}`)
	} catch (err) {
		console.error('❌ 上传异常：', err)
		const msg = err.name === 'AbortError' ? '上传超时' : err.message
		throw new Error('上传失败：' + msg)
	}
}

//注入html方法
export function injectCubePostMessage(rawHtml) {
	const injectCode = `
      (function lightHijack() {
          // 待上报元素标记，防止重复change触发重复上报
          const pendingChangeElements = new WeakMap();

          function syncTotalToParent() {
              if (!(window.parent && window.parent !== window)) return;
              window.parent.postMessage({
                  type: "total_sync",
                  count: typeof targetCount !== "undefined" ? targetCount : 0,
                  max: typeof MAX_CUBES !== "undefined" ? MAX_CUBES : 0,
                  time: Date.now()
              }, "*");
          }
      
          function sendRecord(fnName, args, triggerElInfo = null) {
              if (!(window.parent && window.parent !== window)) return;
              const data = {
                  type: "func_trigger_record",
                  funcName: fnName,
                  args: safeClone(args),
                  triggerElement: triggerElInfo,
                  timestamp: Date.now()
              };
              window.parent.postMessage(data, "*");
          }
      
          function safeClone(val) {
              try {
                  return JSON.parse(JSON.stringify(val));
              } catch (err) {
                  return String(val);
              }
          }
      
          function getElementMeta(el) {
              if (!el || !(el instanceof HTMLElement)) return null;
              return {
                  id: el.id || "",
                  tagName: el.tagName.toLowerCase(),
                  text: (el.innerText || "").trim(),
                  value: el.value !== undefined ? el.value : "",
                  className: el.className || "",
                  type: el.type || ""
              };
          }
      
          function parseOnclick(codeStr) {
              const funcMatch = codeStr.match(/^\\s*([a-zA-Z0-9_]+)\\s*\\(/);
              const argMatch = codeStr.match(/\\((.*?)\\)/);
              let funcName = "";
              let args = [];
      
              if (funcMatch) funcName = funcMatch[1];
              if (argMatch && argMatch[1].trim()) {
                  const rawArgs = argMatch[1].split(',').map(item => item.trim());
                  args = rawArgs.map(arg => {
                      if (/^\\d+(\\.\\d+)?$/.test(arg)) return Number(arg);
                      if (/^["'].*["']$/.test(arg)) return arg.slice(1, -1);
                      return arg;
                  });
              }
              return { funcName, args };
          }
      
          document.addEventListener('click', function(e) {
                        const target = e.target;
                        if(target.tagName !== 'BUTTON') return;
                        const elMeta = getElementMeta(target);
                        const onclickCode = target.getAttribute('onclick') || "";
                        const parseResult = parseOnclick(onclickCode);
          
                        setTimeout(function(){
                            let reportArgs = parseResult.args || [];
                            let reportFuncName = parseResult.funcName || "";
          
                            if(!reportFuncName) {
                                reportFuncName = "button_toggle";
                                const latestDataState = target.getAttribute('data-state') || "";
                                reportArgs = [latestDataState];
                            }
                            elMeta.value = JSON.stringify(reportArgs);
                            sendRecord(reportFuncName, reportArgs, elMeta);
                        }, 0);
                    }, true);
      
          // Enter按下：强制失焦，保证一定触发change事件，避免页面不blur导致采集丢失
          document.addEventListener('keydown', function(e) {
              const target = e.target;
              if(!["INPUT","TEXTAREA"].includes(target.tagName)) return;
              if(e.key !== 'Enter' && e.keyCode !== 13) return;
              setTimeout(()=>{
                  if(!target.isConnected) return;
                  target.blur();
              },0);
          }, true);

          // change捕获阶段：仅打标记，不读值；等待页面自身change回调全部执行完毕再上报
          document.addEventListener('change', function(e) {
              const target = e.target;
              if (!["INPUT","TEXTAREA"].includes(target.tagName)) return;
              if(pendingChangeElements.has(target)) return;
              pendingChangeElements.set(target, true);

              queueMicrotask(() => {
                  setTimeout(() => {
                      pendingChangeElements.delete(target);
                      if (!target.isConnected) return;
                      const elMeta = getElementMeta(target);
                      sendRecord("input_change", [target.value], elMeta);
                  }, 0);
              });
          }, true);
      
          window.addEventListener('message', function(event) {
              const msg = event.data;
              if (msg.type !== "trigger_btn") return;
              const { funcName, args = [], targetId = "" } = msg;
    
              if (funcName === "input_change" && targetId) {
                  const inputEl = document.getElementById(targetId);
                  if (inputEl) {
                      inputEl.value = args[0] ?? "";
                      const inputEvt = new InputEvent('input', {
                          bubbles: true,
                          cancelable: true,
                          inputType: 'insertText'
                      });
                      inputEl.dispatchEvent(inputEvt);
                      const changeEvt = new Event('change', {
                          bubbles: true,
                          cancelable: true
                      });
                      inputEl.dispatchEvent(changeEvt);
                  }
                  return;
              }
    
              if (funcName && window[funcName] && typeof window[funcName] === "function") {
                  window[funcName].apply(window, args);
                  return;
              }
    
              if (targetId) {
                  const btnEl = document.getElementById(targetId);
                  if (btnEl) btnEl.click();
                  return;
              }
              console.warn("[回放] 无可用函数名与元素ID，跳过执行");
          });
      
          let targetCountWatch = window.targetCount;
          Object.defineProperty(window, "targetCount", {
              get() { return targetCountWatch; },
              set(val) {
                  if(targetCountWatch !== val) {
                      targetCountWatch = val;
                      syncTotalToParent();
                  }
              }
          });
      
          window.addEventListener('load', syncTotalToParent);
      })();
      `;
	let html = rawHtml;
	html = html.replace(/<script(?![\s\S]*src=)(?![\s\S]*type=)>/, `<script>${injectCode}`);
	return html;
}





//模型图片上传
export async function ModelUploadParam(blobUrl, submitData, type) {
	const blobToFile = async (blobUrl, filename) => {
		const res = await fetch(blobUrl)
		const blob = await res.blob()
		const file = new File([blob], filename, {
			type: blob.type
		})
		URL.revokeObjectURL(blobUrl)
		return file
	}
	try {
		const fileName = `model_img_${Date.now()}.png`
		console.log('执行fileName', fileName)
		const file = await blobToFile(blobUrl, fileName)
		console.log('file', file)
		const ossData = await ModelUpload(submitData.id)
		console.log('ossData', ossData)
		//执行上传服务器
		let url = `${ossData.dir}${ossData.uuid}.png`
		console.log('url', url)
		const realUrl = await uploadToOss(file, ossData)
		console.log('realUrl', realUrl)
		const isMsy = await postModelResourceAdd(submitData, type, url)
		//执行数据写入数据库并且返回数据库地址
		if (isMsy) {
			return true
		} else {
			return false
		}
	} catch (err) {
		return false
	}

}
export async function postModelResourceAdd(submitData, type, url) {
	try {
		await API.post(API.admin.postModelResourceAdd, {
			aiStandardModelId: submitData.id,
			type: type,
			src: url
		})
		return true
	} catch (error) {
		return false
	}
}
export async function ModelUpload(modelId) {
	try {
		const res = await API.get(API.fileurl.getModelUploadParam, {
			orgId: localStorage.getItem('orgId') || '',
			modelId: modelId || '',
			userId: localStorage.getItem('userId'),
			userType: localStorage.getItem('userType')
		})
		return res.data
	} catch (error) {
		console.error('获取上传凭证失败：', error)
		Message.error('获取上传参数失败')
		throw error
	}
}